<ng-container *ngIf="model$ | async as model">
  <tax-page-header [showBackButton]="true" [titleAdditionalInfo]="pageHeader">
    <div class="layout-2-corner-column" *ngIf="model.ticket as ticket">
      <span class="tall-text" data-qa="fiscal-id">ФП {{ ticket.fiscalId }}</span>
      <a
        data-qa-link="pdf-ticket"
        target="_blank"
        href="/api/ticket/{{ ticket.transactionId }}/get-pdf?ticketDate={{
          ticket.transactionDate
        }}"
      >
        <tax-icon class="download-icon" name="download"></tax-icon>
      </a>
    </div>
  </tax-page-header>

  <section class="ticket" data-qa-block="transaction">
    <tax-ticket-information [ticketModel]="model"></tax-ticket-information>
    <tax-ticket-transaction-table [ticketModel]="model"></tax-ticket-transaction-table>
  </section>

  <ng-template #pageHeader>
    <span class="page-header" data-qa="ticket-header-description">
      <ng-container
        *ngFor="let item of model | ticketDescription; trackBy: trackByDescriptionIndex"
      >
        {{ item | translate }}
      </ng-container>
    </span>
  </ng-template>
</ng-container>
